import { type FormInstance } from 'antd';
import { type UnknownAction } from 'redux';

import { EHotkey } from '../hooks/use-hotkey';

export type CallbackAction = (text: string) => UnknownAction | void;

export const FORM_TEXT_HOTKEYS: EHotkey[] = [
  EHotkey.PASTE_NAME,
  EHotkey.SUBMIT_FORM,
];

export const FormTextHandler = async (
  form: FormInstance,
  hotkey: EHotkey,
  cb: CallbackAction,
): Promise<void> => {
  if (hotkey === EHotkey.SUBMIT_FORM) {
    form.submit();

    return;
  }

  if (hotkey !== EHotkey.PASTE_NAME) {
    return;
  }

  const text: string = await navigator.clipboard.readText();

  if (cb && text) {
    cb(text.trim());
  }
};

export const AddFocusEventListener = (
  form: FormInstance,
  cb: CallbackAction,
): void => {
  window.addEventListener(
    'focus',
    async (): Promise<void> => {
      const text: string = await navigator.clipboard.readText();
      const tt: string = text.trim();

      if (cb && tt) {
        cb(tt);
      }

      form.submit();
    },
    { once: true },
  );
};
